import React, { useContext } from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'
import BootstrapDataContext from '../../context/BootstrapDataContext'

type TemplateProps = {
  additionalLinks?: LinkTag[]
  brandUrl: string
  description: string
  favicons: LinkTag[]
  googleVerification?: string
  imageUrl: string
  title: string
  twitterHandle: string
}

export type LinkTag = {
  href: string
  rel: string
  type?: string
}

export const renderLinks = (linkTags: LinkTag[]) =>
  linkTags.map(linkTag => <link key={linkTag.href} {...linkTag} />)

const Template = ({
  additionalLinks,
  brandUrl,
  description,
  favicons,
  googleVerification,
  imageUrl,
  title,
  twitterHandle
}: TemplateProps) => {
  const router = useRouter()
  const { pathname = '/vacationpackages' } = router
  const { baseUrl, isMobile = false } = useContext(BootstrapDataContext)
  const pageUrl = `${baseUrl}${pathname}`

  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta charSet="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
        <meta property="og:title" content={title} />
        <meta property="og:url" content={brandUrl} />
        <meta property="og:image" content={imageUrl} />
        <meta property="og:description" content={description} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:url" content={brandUrl} />
        <meta name="twitter:image" content={imageUrl} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content={twitterHandle} />
        <meta name="robots" content="noydir,noodp" />
        <meta name="language" content="english" />
        <meta
          name="description"
          className="description"
          content={description}
        />
        <meta
          name="google-site-verification"
          content="NfW_2qut5D0YEqJE2_8tqKYUKrWju1NsVFUc4Kxl7Sw"
        />
        <meta
          name="google-site-verification"
          content="F8oXNWFYF1zWWLC_bBMEiUaKq588GpL8o0r0r30sQtk"
        />
        {googleVerification && (
          <meta name="google-site-verification" content={googleVerification} />
        )}
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no height=device-height"
        />
        <meta httpEquiv="Pragma" content="no-cache" />
        <meta httpEquiv="Expires" content="-1" />
        <meta httpEquiv="Expires" content="Tue, 01 Jan 1980 1:00:00 GMT" />
        <meta
          httpEquiv="Cache-Control"
          content="no-store, no-cache, must-revalidate, post-check=0, pre-check=0"
        />
        <meta httpEquiv="Cache-Control" content="max-age=0" />
        {favicons && renderLinks(favicons)}
        <link rel="canonical" href={pageUrl} />
        {additionalLinks && renderLinks(additionalLinks)}
        <link
          rel="preconnect"
          href="https://fonts.googleapis.com"
          crossOrigin="true"
        />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="true"
        />
        <title>{title}</title>
        <link
          rel="stylesheet"
          href={`https://fonts.googleapis.com/css?family=Montserrat:${
            isMobile ? '400,600' : '500,700'
          }`}
        />
      </Head>
    </>
  )
}

export default Template
